import { Component, OnInit, HostBinding, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SharedService, MetaService } from './../../services';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor(
    private titleService: Title,
    private _shared: SharedService,
    private _meta: MetaService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
  ) { 
    this.titleService.setTitle('Pogoda.by | Страница не найдена');
  }

  @HostBinding('style.height') height = 'calc(100vh - 71px - 50px)';
  contentMinHeight;
  haveStorm;
  haveHydroStorm; 
  footerHeight;

  ngAfterViewChecked(){
    this._shared.currentFooterHeight.subscribe(state => {
      this.contentMinHeight = `calc(100% - ${state}px)`;
    });
    this.cdr.detectChanges();
  }

  ngOnInit() {
    this._meta.update(this.route.snapshot.data);
    this._shared.currentStorm.subscribe(state => {
      this.haveStorm = state;
      this.height = `calc(100vh - 71px - 50px ${this.haveStorm ? '- 40px' : ''} ${this.haveHydroStorm ? '- 40px' : ''})`;
    });
    this._shared.currentHydroStorm.subscribe(state => {
      this.haveHydroStorm = state;
      this.height = `calc(100vh - 71px - 50px ${this.haveStorm ? '- 40px' : ''} ${this.haveHydroStorm ? '- 40px' : ''})`;
    });
  }

}
